import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FiOnboardingConnectEditComponent } from './fi-onboarding-connect-edit.component';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiEditorPageHeaderModule } from '@fi-shared/fi-editor-page-header/fi-editor-page-header.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiOnboardingConnectEditEditorTabComponent } from './fi-editor-tab/fi-editor-tab.component';
import { FiNameDescriptionInputModule } from '@fi-app/shared/name-description-input/name-description-input.module';
import { MatCardModule } from '@angular/material/card';
import { FiConnectOnboardingItemSelectComponent } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-connect-edit/fi-editor-tab/fi-connect-onboarding-item-select/fi-connect-onboarding-item-select.component';
import { MatButtonModule } from '@angular/material/button';
import { FiConditionalLogicTabComponent } from './fi-conditional-logic-tab/fi-conditional-logic-tab.component';
import { FiInfoBannerModule } from '@fi-app/shared/fi-info-banner/fi-info-banner.module';
import { FiConditionalLogicConditionEditorDialogComponent } from './fi-conditional-logic-tab/fi-condition-editor-dialog/fi-condition-editor-dialog.component';
import { FiActivateTabComponent } from './fi-activate-tab/fi-activate-tab.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        MatSelectModule,
        FiValidatingFormModule,
        FiEditorPageHeaderModule,
        MatTabsModule,
        FiAppTextSharedModule,
        MatCardModule,
        FiNameDescriptionInputModule,
        MatButtonModule,
        FiInfoBannerModule,
    ],
    declarations: [
        FiOnboardingConnectEditComponent,
        FiOnboardingConnectEditEditorTabComponent,
        FiConnectOnboardingItemSelectComponent,
        FiConditionalLogicTabComponent,
        FiConditionalLogicConditionEditorDialogComponent,
        FiActivateTabComponent,
    ],
})
export class FiOnboardingConnectEditModule {}
